import React from "react";

export default function TermsAndConditions() {
  const sections = [
    {
      num: "01",
      eyebrow: "Overview",
      title: "Introduction",
      content: (
        <p className="tc-text">
          Welcome to <strong>VESHH-EON</strong> ("we", "us", "our"), a clothing brand operated from Belagavi, Karnataka, India. By accessing our website at <strong>veshheon.in</strong> or placing an order with us, you confirm that you have read, understood, and agree to be bound by these Terms and Conditions in their entirety. If you do not agree, please discontinue use of our website immediately.
        </p>
      ),
    },
    {
      num: "02",
      eyebrow: "Eligibility",
      title: "Age & Eligibility",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">You must be at least <strong>18 years of age</strong> to place an order on our website. By transacting with us, you represent and warrant that you meet this age requirement. Under the Indian Contract Act, 1872, minors are not legally capable of entering into contracts.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">By using this website, you represent that you are legally capable of entering into binding contracts under applicable Indian law.</p>
          </div>
        </div>
      ),
    },
    {
      num: "03",
      eyebrow: "Usage",
      title: "General Use",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">The content on this website is subject to change without prior notice. We reserve the right to modify, suspend, or discontinue any part of the website at any time.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We and any third parties do not provide warranties regarding the accuracy, completeness, timeliness, or suitability of the information provided. You acknowledge that such information may contain inaccuracies or errors, and we exclude liability for these to the fullest extent permitted by law.</p>
          </div>
        </div>
      ),
    },
    {
      num: "04",
      eyebrow: "Accounts",
      title: "Account Security",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">If you create an account on our website, you are solely responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">You must notify us immediately at <strong>support@veshheon.in</strong> if you suspect any unauthorized use of your account. We shall not be liable for any loss arising from unauthorized use of your account due to your failure to safeguard your credentials.</p>
          </div>
        </div>
      ),
    },
    {
      num: "05",
      eyebrow: "Orders",
      title: "Order & Contract Formation",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Placing an order on our website constitutes an offer to purchase the selected product(s). A legally binding contract is formed only upon our dispatch of the order and issuance of a shipment confirmation to your registered email address.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We reserve the right to cancel or refuse any order at our discretion — including in cases of pricing errors, unavailability of stock, or suspected fraudulent activity — without any obligation to the customer beyond a full refund of amounts paid.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Order confirmation emails are for reference only and do not constitute acceptance of your order.</p>
          </div>
        </div>
      ),
    },
    {
      num: "06",
      eyebrow: "Pricing",
      title: "Pricing & GST",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">All prices displayed on our website are in <strong>Indian Rupees (INR)</strong> and are inclusive of applicable Goods and Services Tax (GST) as required under the CGST Act, 2017, unless explicitly stated otherwise.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We reserve the right to correct any pricing errors at any time. If an item is listed at an incorrect price due to a typographical or system error, we reserve the right to cancel orders placed at the erroneous price and refund the full amount collected.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Shipping charges, if applicable, will be disclosed at checkout before payment confirmation.</p>
          </div>
        </div>
      ),
    },
    {
      num: "07",
      eyebrow: "Payments",
      title: "Payment Terms",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We accept payments via UPI, debit/credit cards, net banking, and other methods made available at checkout. All transactions are processed through secure, third-party payment gateways.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We do not store your full payment card details on our servers. All payment information is handled directly by our payment gateway partners in compliance with applicable security standards.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">In the event of a payment failure or declined transaction, your order will not be processed. We are not liable for any charges imposed by your bank or payment provider in such instances.</p>
          </div>
        </div>
      ),
    },
    {
      num: "08",
      eyebrow: "Delivery",
      title: "Shipping & Delivery",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We ship across India through registered courier partners. Estimated delivery timelines are indicative and may vary based on your location, courier availability, and other external factors.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We are not responsible for delays caused by our logistics partners, natural events, strikes, or government-imposed restrictions. Risk of loss and title for products passes to you upon delivery.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">It is your responsibility to provide an accurate and complete delivery address. We shall not be liable for non-delivery or mis-delivery arising from incorrect address information.</p>
          </div>
        </div>
      ),
    },
    {
      num: "09",
      eyebrow: "Your Role",
      title: "User Responsibility",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Your use of any information or materials on this site is entirely at your own risk.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">It is your responsibility to ensure that products, services, or information available through our website meet your specific requirements before completing a purchase.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">You agree not to use our website for any unlawful purpose, to transmit any harmful or malicious content, or to engage in any activity that could disrupt or damage our platform.</p>
          </div>
        </div>
      ),
    },
    {
      num: "10",
      eyebrow: "Ownership",
      title: "Intellectual Property",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text"><strong>VESHH-EON</strong> and all associated logos, brand names, product names, designs, graphics, and website content are the exclusive intellectual property of VESHH-EON. Unauthorized reproduction, distribution, or commercial use is strictly prohibited.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Our designs, prints, and garment aesthetics are original works protected under the Copyright Act, 1957. Any attempt to replicate or imitate our creative output will be treated as infringement and pursued accordingly.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">All trademarks not owned by us that appear on the website are acknowledged as the property of their respective owners.</p>
          </div>
        </div>
      ),
    },
    {
      num: "11",
      eyebrow: "Brand Protection",
      title: "Anti-Counterfeiting",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">The VESHH-EON name, wordmark, and associated design identities are proprietary. Manufacturing, selling, or distributing counterfeit or imitation products bearing our name or visual identity is a violation of applicable Indian law including the Trade Marks Act, 1999.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We actively monitor for brand misuse and reserve the right to take legal action against any entity found to be infringing on our intellectual property rights.</p>
          </div>
        </div>
      ),
    },
    {
      num: "12",
      eyebrow: "Limitations",
      title: "Restrictions",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Unauthorized use of the information provided may give rise to claims for damages and/or constitute a criminal offense under applicable Indian law.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">You may not link to our website without prior written consent from VESHH-EON.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Scraping, data mining, or automated access to our website without permission is strictly prohibited.</p>
          </div>
        </div>
      ),
    },
    {
      num: "13",
      eyebrow: "External",
      title: "Third-Party Links",
      content: (
        <p className="tc-text">
          Our site may contain links to third-party websites for your convenience. These links do not constitute endorsement of those sites. We hold no responsibility for the content, privacy practices, or accuracy of any linked third-party website. Visiting such sites is at your own risk.
        </p>
      ),
    },
    {
      num: "14",
      eyebrow: "Data",
      title: "Privacy & Data",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Your personal data collected during use of this website is handled in accordance with our Privacy Policy and in compliance with the Information Technology Act, 2000, the IT (Amendment) Act, 2008, and the Digital Personal Data Protection Act, 2023.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">By using our website, you consent to the collection and processing of your data as described in our Privacy Policy. We do not sell your personal information to third parties.</p>
          </div>
        </div>
      ),
    },
    {
      num: "15",
      eyebrow: "Circumstances",
      title: "Force Majeure",
      content: (
        <p className="tc-text">
          We shall not be held liable for any failure or delay in performance of our obligations under these Terms where such failure or delay results from circumstances beyond our reasonable control — including but not limited to natural disasters, acts of government, courier strikes, pandemics, internet or power outages, or civil unrest. In such events, our obligations will be suspended for the duration of the disruption.
        </p>
      ),
    },
    {
      num: "16",
      eyebrow: "Liability",
      title: "Limitation of Liability",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We hold no liability for any direct or indirect loss or damage arising out of the decline of authorization for any transaction, including instances where cardholders exceed preset limits agreed with our acquiring bank.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">To the maximum extent permitted under Indian law, our aggregate liability to you for any claim arising from use of our website or purchase of our products shall not exceed the amount paid by you for the specific order giving rise to the claim.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">We are not liable for any consequential, incidental, or indirect damages including loss of profit, data, or business opportunity arising from your use of our website or products.</p>
          </div>
        </div>
      ),
    },
    {
      num: "17",
      eyebrow: "Jurisdiction",
      title: "Governing Law & Disputes",
      content: (
        <div className="tc-items">
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">These Terms shall be governed by and construed in accordance with the laws of India. Any dispute, claim, or controversy arising from or relating to these Terms or your use of our website shall be subject to the exclusive jurisdiction of the courts located in <strong>Belagavi, Karnataka, Bharat</strong>.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Before initiating any legal proceedings, you agree to first attempt resolution by contacting us at <strong>support@veshheon.in</strong>. We will make reasonable efforts to resolve disputes amicably within 30 days of receiving written notice.</p>
          </div>
          <div className="tc-item">
            <span className="tc-dash">—</span>
            <p className="tc-text">Your statutory rights as a consumer under the Consumer Protection Act, 2019 remain unaffected by these Terms.</p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <style>{tcStyles}</style>

      <div className="tc-root">

        {/* ── HEADER ── */}
        <div className="tc-header">
          <div>
            <span className="tc-eyebrow">Last Updated · July 1, 2025</span>
            <h1 className="tc-title">Terms &amp; <span className="tc-title-bold">Conditions</span></h1>
          </div>
        </div>

        <div className="tc-rule-wrap"><hr className="tc-hr" /></div>

        {/* ── INTRO PULL ── */}
        <div className="tc-intro-wrap">
          <p className="tc-pull">
            "By accessing our website or placing an order with us, you confirm that you have read, understood, and agree to be bound by these Terms in their entirety."
          </p>
        </div>

        <div className="tc-rule-wrap"><hr className="tc-hr" /></div>

        {/* ── SECTIONS ── */}
        <div className="tc-sections">
          {sections.map((s, i) => {
            const words = s.title.split(" ");
            const light = words.slice(0, -1).join(" ");
            const bold = words[words.length - 1];
            return (
              <React.Fragment key={s.num}>
                <section className="tc-section">
                  <div className="tc-section-meta">
                    <span className="tc-section-num">{s.num}</span>
                    <div>
                      <span className="tc-section-eyebrow">{s.eyebrow}</span>
                      <h2 className="tc-section-title">
                        {light && <span className="tc-section-light">{light} </span>}
                        <span className="tc-section-bold">{bold}</span>
                      </h2>
                    </div>
                  </div>
                  <div className="tc-section-body">
                    {s.content}
                  </div>
                </section>
                {i < sections.length - 1 && (
                  <div className="tc-rule-wrap"><hr className="tc-hr" /></div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* ── CLOSING ── */}
        <div className="tc-rule-wrap"><hr className="tc-hr" /></div>
        <div className="tc-closing">
          <span className="tc-closing-text">VESHH-EON · Terms &amp; Conditions · Belagavi, Karnataka, Bharat · July 2025</span>
        </div>

      </div>
    </>
  );
}

const tcStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,200;0,300;0,400;0,500;0,600;1,300&display=swap');

  .tc-root {
    background: #f8f8f8;
    min-height: 100vh;
    font-family: 'Exo 2', sans-serif;
    padding-bottom: 80px;
  }

  .tc-header {
    max-width: 1200px;
    margin: 0 auto;
    padding: 64px 80px 40px;
  }

  .tc-eyebrow {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 12px;
  }
  .tc-eyebrow::before {
    content: '';
    width: 24px;
    height: 1px;
    background: black;
    display: block;
    flex-shrink: 0;
  }

  .tc-title {
    font-size: clamp(32px, 4.5vw, 60px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  .tc-title-bold { font-weight: 600; }

  .tc-rule-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }
  .tc-hr {
    border: none;
    border-top: 1px solid black;
    margin: 0;
  }

  .tc-intro-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 80px;
  }

  .tc-pull {
    font-size: clamp(13px, 1.6vw, 17px);
    font-weight: 300;
    font-style: italic;
    color: black;
    line-height: 1.8;
    border-left: 2px solid black;
    padding-left: 20px;
    margin: 0;
    max-width: 720px;
    letter-spacing: 0.02em;
  }

  .tc-sections {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }

  .tc-section {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 60px;
    padding: 52px 0;
  }

  .tc-section-meta {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .tc-section-num {
    font-size: 64px;
    font-weight: 200;
    color: black;
    line-height: 1;
    letter-spacing: -0.02em;
    display: block;
  }

  .tc-section-eyebrow {
    display: block;
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 8px;
  }

  .tc-section-title {
    font-size: clamp(16px, 2vw, 28px);
    line-height: 1.1;
    margin: 0;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .tc-section-light { font-weight: 200; color: #000; }
  .tc-section-bold  { font-weight: 600; color: #000; }

  .tc-section-body { padding-top: 6px; }

  .tc-text {
    font-size: 13px;
    font-weight: 300;
    color: black;
    line-height: 2;
    letter-spacing: 0.04em;
    text-align: justify;
    margin: 0;
  }

  .tc-items { display: flex; flex-direction: column; gap: 14px; }

  .tc-item { display: flex; align-items: flex-start; gap: 14px; }

  .tc-dash {
    font-size: 13px;
    font-weight: 300;
    color: black;
    flex-shrink: 0;
    padding-top: 2px;
  }

  .tc-closing {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px 80px 0;
    text-align: center;
  }

  .tc-closing-text {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    color: black;
  }

  @media (max-width: 1024px) {
    .tc-header     { padding: 48px 40px 32px; }
    .tc-rule-wrap  { padding: 0 40px; }
    .tc-intro-wrap { padding: 40px 40px; }
    .tc-sections   { padding: 0 40px; }
    .tc-closing    { padding: 20px 40px 0; }
    .tc-section    { grid-template-columns: 200px 1fr; gap: 40px; }
  }

  @media (max-width: 768px) {
    .tc-header     { padding: 40px 20px 28px; }
    .tc-rule-wrap  { padding: 0 20px; }
    .tc-intro-wrap { padding: 36px 20px; }
    .tc-sections   { padding: 0 20px; }
    .tc-closing    { padding: 20px 20px 0; }
    .tc-section    { grid-template-columns: 1fr; gap: 20px; padding: 40px 0; }
    .tc-section-meta { flex-direction: row; align-items: flex-end; gap: 14px; }
    .tc-section-num  { font-size: 44px; }
  }

  @media (max-width: 360px) {
    .tc-header     { padding: 32px 14px 24px; }
    .tc-rule-wrap  { padding: 0 14px; }
    .tc-intro-wrap { padding: 28px 14px; }
    .tc-sections   { padding: 0 14px; }
    .tc-closing    { padding: 16px 14px 0; }
  }
`;
